import React from 'react'
import scrollSnapPolyfill from 'css-scroll-snap-polyfill'

import './ScrollerSelect.scss'

interface Item {
    id: number,
    label: string
}

interface Props {
    activeId: number,
    listItems: Item[]
    onUpdate: Function
}

interface State {
    listItems: Item[],
    activeId: number | null
}

const defaultState = {
    listItems: [],
    activeId: null
}

const LIST_ITEM_WIDTH = 87 // px
let TIMER_SCROLL: NodeJS.Timer

export default class ScrollerSelect extends React.Component<Props, State> {

    static getDerivedStateFromProps ( nextProps: Props, prevState: State ) {

        if (nextProps.listItems.length > 0) {
            return {
                ...nextProps,
                ...prevState
            }
        } else {
            return nextProps
        }
    }

    constructor(props: Props) {
        super(props)
        this.state = defaultState
    }

    public setActiveId = ( id: number ) => {
        const $wrapper = document.querySelector('#scroller-select .wrapper')

        const itemIndex = this.props.listItems.findIndex( (val: Item) => val.id === id )
        if ( $wrapper ) {
            $wrapper.scrollLeft = itemIndex * LIST_ITEM_WIDTH
        }
    }

    public setSelectedItemState = (item: number) => {
        this.props.onUpdate(item)
    }

    public highlightActiveId = () => {
        const $wrapper = document.querySelector('#scroller-select .wrapper')

        if ( $wrapper ) {
            const $listItems = $wrapper.querySelectorAll('li[data-id]')

            if ($listItems.length > 0 ) {

                Array.from($listItems).map( ($elem: HTMLElement, index: number) => {

                    let offsetLeft = $elem.getBoundingClientRect().left
                    let windowWidth = window.innerWidth / 2
                    let itemMinOffset = (windowWidth - (LIST_ITEM_WIDTH / 2 + 1))
                    let itemMaxOffset = (windowWidth + (LIST_ITEM_WIDTH / 2 - 1.5))

                    if ( offsetLeft >= itemMinOffset && offsetLeft <= itemMaxOffset) {
                        if (!$elem.classList.contains('active')) {
                            $elem.classList.add('active')
                            const item: number = $elem.dataset.id ? parseInt($elem.dataset.id, 10) : this.props.activeId
                            this.setSelectedItemState(item)
                        }
                    } else {
                        $elem.classList.remove('active')
                    }
                })
            }
        }
    }

    public handleScroll = (event: Object) => {
        if (TIMER_SCROLL) {
            clearTimeout(TIMER_SCROLL)
        }
        TIMER_SCROLL = global.setTimeout( () => this.highlightActiveId(), 100)
    }

    public handleClick = (item: number) => {
        this.setActiveId(item)
    }

    public componentDidMount () {
        scrollSnapPolyfill()
        this.setActiveId(this.props.activeId)
        global.setTimeout( () => this.highlightActiveId(), 0)
    }

    public render() {
        return(
            <div id="scroller-select">
                <div className="selected"/>
                <div className="scroll-overflow">
                    <ul className="wrapper" onScroll={this.handleScroll}>
                        <li className="first"/>
                            {this.props.listItems.map((item: Item, index: number) =>
                                <li
                                    data-id={item.id}
                                    key={index}
                                    onClick={(event) => this.handleClick(item.id)}
                                >
                                    {item.label}
                                </li>
                            )}
                        <li className="last"/>
                    </ul>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/ScrollerSelect/index.tsx